export interface GraficoPizzaDouble {
    titulo: string;
    titulos: string[];
    valores: number[];
    media: string | null;
    total: string;
}

export const emptyGraficoPizzaDouble: GraficoPizzaDouble = {
    titulo: "",
    titulos: [],
    valores: [],
    media: null,
    total: "",
};